import PlayerLoadingSpin from "components/shared/PlayerLoadingSpin";
import React from "react";
import {
  AiFillPauseCircle,
  AiFillPlayCircle,
  AiFillStepBackward,
  AiFillStepForward,
} from "react-icons/ai";
import { FiShuffle } from "react-icons/fi";
import { TbRepeat, TbRepeatOff, TbRepeatOnce } from "react-icons/tb";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { formatDurationHr_Min_Sec } from "utils/timeFunctions";

function ControlButtons({
  fullScreen,
  isPlaying,
  loadingStreamingUrl,
  togglePlayPause,
  skipForward,
  skipBack,
  toggleShuffle,
  isRandom,
  currentTime,
  repeat,
  setRepeat,
  duration,
  playlist,
  music,
  radio,
  podcast,
}: any) {
  const handleRepeat = () => {
    if (!isRandom) {
      if (repeat === 0) {
        setRepeat(1);
      } else if (repeat === 1) {
        setRepeat(2);
      } else {
        setRepeat(0);
      }
    }
  };

  const hasMultiple = playlist?.length > 1;

  // glass icon button
  const glassBtn =
    "flex h-9 w-9 items-center justify-center rounded-full border border-white/10 bg-white/5 backdrop-blur-md transition-colors hover:bg-white/15";

  return (
    <>
      {/* play time */}
      {!radio && !fullScreen && (
        <p className="min-w-[50px] text-center text-xs tabular-nums text-white/60 max-md:hidden">
          {currentTime ? formatDurationHr_Min_Sec(currentTime) : "00:00"}
        </p>
      )}

      {/* shuffle btn */}
      {toggleShuffle && (
        <div
          className={`loop-button ${glassBtn} max-sm:hidden cursor-pointer text-lg`}
          onClick={toggleShuffle}
        >
          <FiShuffle
            className={`transition-colors ${
              isRandom ? "text-red-500" : "text-white/70"
            }`}
            data-tooltip-id={`audio-player-shuffle`}
          />
          <div className="text-sm">
            <ReactTooltip
              id={`audio-player-shuffle`}
              place="top"
              content={"Shuffle"}
            />
          </div>
        </div>
      )}

      {/* backward btn */}
      {skipBack && (
        <div
          className={`skip-back-button ${glassBtn} cursor-pointer text-lg`}
          onClick={skipBack}
        >
          <AiFillStepBackward
            data-tooltip-id={`audio-player-previous`}
            className={
              hasMultiple
                ? `text-white`
                : `cursor-not-allowed text-white/25`
            }
          />
          <div className="text-sm">
            <ReactTooltip
              id={`audio-player-previous`}
              place="top"
              content={music ? `Previous Song` : `Previous Podcast`}
            />
          </div>
        </div>
      )}

      {/* play button (prominent glass circle) */}
      <div
        className="play-pause-button group flex h-12 w-12 cursor-pointer items-center justify-center rounded-full border border-white/15 bg-white/10 text-3xl text-white shadow-[0_4px_20px_rgba(0,0,0,0.35)] backdrop-blur-md transition-colors hover:bg-white/20"
        onClick={togglePlayPause}
      >
        {loadingStreamingUrl ? (
          <PlayerLoadingSpin />
        ) : isPlaying ? (
          <AiFillPauseCircle
            data-tooltip-id={`audio-player-play-pause`}
            className={`transition-colors group-hover:text-red-500 ${
              radio && `scale-[1.4]`
            }`}
          />
        ) : (
          <AiFillPlayCircle
            data-tooltip-id={`audio-player-play-pause`}
            className={`transition-colors group-hover:text-red-500 ${
              radio && `scale-[1.4]`
            }`}
          />
        )}
        <div className="text-sm">
          <ReactTooltip
            id={`audio-player-play-pause`}
            place="top"
            content={isPlaying ? "Pause" : "Play"}
          />
        </div>
      </div>

      {/* forward btn */}
      {skipForward && (
        <div
          className={`skip-forward-button ${glassBtn} cursor-pointer text-lg`}
          onClick={skipForward}
        >
          <AiFillStepForward
            data-tooltip-id={`audio-player-next`}
            className={
              hasMultiple
                ? `text-white`
                : `cursor-not-allowed text-white/25`
            }
          />
          <div className="text-sm">
            <ReactTooltip
              id={`audio-player-next`}
              place="top"
              content={music ? `Next Song` : `Next Podcast`}
            />
          </div>
        </div>
      )}

      {/* repeat btn */}
      {handleRepeat && !radio && (
        <div className="repeat-button max-sm:hidden">
          <button
            className={`${glassBtn} cursor-pointer text-lg ${
              isRandom
                ? "text-white/25"
                : repeat === 0
                ? "text-white/70"
                : "text-red-500"
            }`}
            disabled={isRandom ? true : false}
            onClick={handleRepeat}
            data-tooltip-id={`audio-player-repeat`}
          >
            {repeat === 0 ? (
              <TbRepeat />
            ) : repeat === 1 ? (
              <TbRepeatOnce />
            ) : (
              <TbRepeatOff />
            )}
            <div className="text-sm">
              {!isRandom && (
                <ReactTooltip
                  id={`audio-player-repeat`}
                  place="top"
                  content={
                    repeat === 0
                      ? "Repeat list"
                      : repeat === 1
                      ? "Repeat current song"
                      : "No repeat"
                  }
                />
              )}
            </div>
          </button>
        </div>
      )}

      {/* duration */}
      {!radio && !fullScreen && (
        <p className="min-w-[50px] text-center text-xs tabular-nums text-white/60 max-md:hidden">
          {duration ? formatDurationHr_Min_Sec(duration) : "00:00"}
        </p>
      )}
    </>
  );
}

export default ControlButtons;